import FranchiseApi from "../api/service/franchise/FranchiseApi";
import LMPAuthApi from "../api/lmp/LMPAuthApi";
import LocalStorageKey from "../common/enums/LocalStorageKey";
import { useNavigate } from "react-router-dom";

export default class FranchiseService {
    api;
    lmpApi;

    constructor() {
        this.api = new FranchiseApi();
        this.lmpApi = new LMPAuthApi();
    }

    navigate = useNavigate();

    async getFranchiseList({ page, pageSize, franchiseCode, franchiseName }) {
        return this.api
            .getFranchiseList({ page, pageSize, franchiseCode, franchiseName })
            .then((res) => {
                if (res.resultCode === "0000") {
                    return res.result;
                } else {
                    throw new Error(res.result);
                }
            })
            .catch((err) => {
                console.log("err: ", err.response.data.resultCode);
                if (err.response.data.resultCode === "0102") {
                    this.navigate("/auth");
                }
            });
    }

    async saveFranchise(reqDto) {
        return this.api
            .saveFranchise(reqDto)
            .then((res) => {
                if (res.resultCode === "0000") {
                    this.lmpApi
                        .createRole({
                            accessToken: localStorage.getItem(LocalStorageKey.accessToken),
                            roleId: reqDto.request.countryCode + reqDto.request.franchiseCode + "03701",
                            roleName: reqDto.request.name + " Franchise Manager",
                        })
                        .then((resp) => {
                            this.lmpApi
                                .createRole({
                                    accessToken: localStorage.getItem(LocalStorageKey.accessToken),
                                    roleId: reqDto.request.countryCode + reqDto.request.franchiseCode + "03702",
                                    roleName: reqDto.request.name + " Call Center",
                                    approvers: reqDto.request.countryCode + reqDto.request.franchiseCode + "03701",
                                    approversChanId: "CHN000037",
                                })
                                .catch((err) => {
                                    console.log("err: ", err);
                                });
                            this.lmpApi
                                .createRole({
                                    accessToken: localStorage.getItem(LocalStorageKey.accessToken),
                                    roleId: reqDto.request.countryCode + reqDto.request.franchiseCode + "03703",
                                    roleName: reqDto.request.name + " Store Manager",
                                    approvers: reqDto.request.countryCode + reqDto.request.franchiseCode + "03701",
                                    approversChanId: "CHN000037",
                                })
                                .catch((err) => {
                                    console.log("err: ", err);
                                });
                        })
                        .catch((err) => {
                            console.log("err: ", err);
                        });
                    return res.result;
                } else {
                    return res;
                }
            })
            .catch((err) => {
                console.log("err: ", err.response.data.resultCode);
                if (err.response.data.resultCode === "0102") {
                    this.navigate("/auth");
                    return;
                }
                return err.response.data;
            });
    }

    async getFranchiseInfo({ countryCode, franchiseCode }) {
        return this.api
            .getFranchiseInfo({ countryCode, franchiseCode })
            .then((res) => {
                if (res.resultCode === "0000") {
                    return res.result;
                } else {
                    return res;
                }
            })
            .catch((err) => {
                console.log("err: ", err.response.data.resultCode);
                if (err.response.data.resultCode === "0102") {
                    this.navigate("/auth");
                }
            });
    }

    async updateFranchise(reqDto) {
        return this.api
            .updateFranchise(reqDto)
            .then((res) => {
                console.log("res: ", res);
                if (res.resultCode === "0000") {
                    return res.result;
                } else {
                    return res;
                }
            })
            .catch((err) => {
                console.log("err: ", err);
                if (err.resultCode === "0102") {
                    this.navigate("/auth");
                    return;
                }
                return err.response.data;
            });
    }

    async deleteFranchise({ idFranchise }) {
        return this.api.deleteFranchise({ idFranchise }).then((res) => {
            if (res.resultCode === "0000") {
                return res.result;
            } else {
                return res;
            }
        });
    }

    async checkFranchiseCode({ franchiseCode, countryCode }) {
        return this.api.checkFranchiseCode({ franchiseCode, countryCode }).then((res) => {
            if (res.resultCode === "0000") {
                return res.result;
            } else {
                throw new Error(res.result);
            }
        });
    }
}
